export type PublicSocialNetwork = 'facebook' | 'instagram' | 'linkedin' | 'youtube' | 'x' | 'tiktok';

export type PublicSocialLink = {
  id: PublicSocialNetwork;
  label: string;
  href: string;
};

function readSocialUrl(envKey: string, fallback: string): string {
  const fromEnv = (process.env[envKey] || '').trim();
  return fromEnv || fallback;
}

/** Liens publics — surchargeables via REACT_APP_PUBLIC_SOCIAL_* au build. */
export const PUBLIC_SOCIAL_LINKS: readonly PublicSocialLink[] = [
  {
    id: 'facebook',
    label: 'Suivez-nous sur Facebook',
    href: readSocialUrl('REACT_APP_PUBLIC_SOCIAL_FACEBOOK', 'https://www.facebook.com/jconsultmy'),
  },
  {
    id: 'instagram',
    label: 'Suivez-nous sur Instagram',
    href: readSocialUrl('REACT_APP_PUBLIC_SOCIAL_INSTAGRAM', 'https://www.instagram.com/jconsultmy'),
  },
  {
    id: 'linkedin',
    label: 'Suivez-nous sur LinkedIn',
    href: readSocialUrl(
      'REACT_APP_PUBLIC_SOCIAL_LINKEDIN',
      'https://www.linkedin.com/company/jconsult-my-sarl',
    ),
  },
  {
    id: 'youtube',
    label: 'Suivez-nous sur YouTube',
    href: readSocialUrl('REACT_APP_PUBLIC_SOCIAL_YOUTUBE', 'https://www.youtube.com/@jconsultmy'),
  },
  {
    id: 'x',
    label: 'Suivez-nous sur X',
    href: readSocialUrl('REACT_APP_PUBLIC_SOCIAL_X', 'https://x.com/jconsultmy'),
  },
  {
    id: 'tiktok',
    label: 'Suivez-nous sur TikTok',
    href: readSocialUrl('REACT_APP_PUBLIC_SOCIAL_TIKTOK', 'https://www.tiktok.com/@jconsultmy'),
  },
].filter((link): link is PublicSocialLink => link.href.length > 0);

/** Liens actifs : API admin si fournie, sinon variables d’environnement / défauts. */
export function resolvePublicSocialLinks(links?: readonly PublicSocialLink[] | null): PublicSocialLink[] {
  const source: readonly PublicSocialLink[] = Array.isArray(links) ? links : PUBLIC_SOCIAL_LINKS;
  return source.filter((link) => Boolean(link.href?.trim()));
}
